<template>
    <App v-bind="$attrs" v-on="$listeners" :sessionId="sessionId" :onClickLink="onClickLink">
      <RecentCalls
          v-if="page === 'recent'"
          :postSaveCb="postSaveCb"
          :onClickCancel="onClickCancel"
      />
      <BlockedNumbersCreate
          v-else-if="page === 'create'"
          :postSaveCb="postSaveCb"
          :onClickCancel="onClickCancel"
      />
      <BlockedNumbersIndex v-else :showFilters="showFilters"/>
    </App>
  </template>
  
  <script>
  import {RecentCalls, BlockedNumbersCreate, BlockedNumbersIndex} from 'blocked-numbers-components'
  import App from '../elements/functional-components/App.vue';
  
  export default {
    props:{
      sessionId: {
        type: String,
        required: false,
      },
      page: {
        type: String,
        required: true,
        validator: (v) => ['create', 'index', 'recent'].includes(v),
      },
      postSaveCb: {
          type: Function,
      },
      onClickCancel: {
        type: Function,
      },
      onClickLink: {
        type: Function,
      },
      showFilters: {
        type: Boolean,
        default: true,
      }
    },
    components: {
      App,
      RecentCalls,
      BlockedNumbersCreate,
      BlockedNumbersIndex
    },
  };
  </script>
  
  <style lang="scss">
      @import 'vue-apps-assets/styles/scss/styles.scss';
   .v-application--wrap {
        min-height: fit-content;
      }
  </style>